import {css} from 'lit'; export default css`:host{--traffic-light-x-position:0px;--traffic-light-width:52px}.container{padding-left:calc(var(--goto-spacing-04) + var(--traffic-light-x-position) + var(--traffic-light-width))}`;
    